import { IOptionAnswer, IOptionsAnswer, IValueAnswer } from '@collaborate-health/forms'
import {
  ControlType,
  CreateFormAnswerRequest,
  FormControlAnswerResponse,
  FormControlResponse,
} from '@tabeeb/contracts/main-api/swagger-main-api'

export const mapFormControlAnswerToFormAnswer = (answer: FormControlAnswerResponse, control: FormControlResponse) => {
  if (control.ControlType === ControlType.Selectlist || control.ControlType === ControlType.Radiobuttonlist) {
    const optionAnswer: IOptionAnswer = {
      type: 'option',
      controlId: answer.FormControlId.toString(),
      value: answer.SelectedOptions!.map((option) => ({
        id: option.Id.toString(),
        value: option.Value!,
        order: 0,
      }))[0],
      meta: answer,
    }

    if (!optionAnswer.value) {
      return null
    }

    return optionAnswer
  }

  if (control.ControlType === ControlType.Checkboxlist) {
    const optionsAnswer: IOptionsAnswer = {
      type: 'options',
      controlId: answer.FormControlId.toString(),
      value: answer.SelectedOptions!.map((option, index) => ({
        id: option.Id.toString(),
        value: option.Value!,
        order: index,
      })),
      meta: answer,
    }

    return optionsAnswer
  }

  const valueAnswer: IValueAnswer<string> = {
    type: 'value',
    controlId: answer.FormControlId.toString(),
    value: answer.Value!,
    meta: answer,
  }

  return valueAnswer
}

export const mapFormControlAnswerRequestToFormAnswer = (
  answer: CreateFormAnswerRequest,
  control: FormControlResponse
) => {
  if (control.ControlType === ControlType.Selectlist || control.ControlType === ControlType.Radiobuttonlist) {
    const optionAnswer: IOptionAnswer = {
      type: 'option',
      controlId: answer.FormControlId.toString(),
      value: control
        .Options!.filter((o) => answer.OptionsIds?.includes(o.Id))
        .map((option) => ({
          id: option.Id.toString(),
          value: option.Value!,
          order: 0,
        }))[0],
      meta: answer,
    }

    if (!optionAnswer.value) {
      return null
    }

    return optionAnswer
  }

  if (control.ControlType === ControlType.Checkboxlist) {
    const optionsAnswer: IOptionsAnswer = {
      type: 'options',
      controlId: answer.FormControlId.toString(),
      value:
        control
          .Options!.filter((o) => answer.OptionsIds?.includes(o.Id))
          .map((option) => ({
            id: option.Id.toString(),
            value: option.Value!,
            order: 0,
          })) ?? [],
      meta: answer,
    }

    return optionsAnswer
  }

  const valueAnswer: IValueAnswer<string> = {
    type: 'value',
    controlId: answer.FormControlId.toString(),
    value: answer.Value!,
    meta: answer,
  }

  return valueAnswer
}

